function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LearnMore = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../../Button");
var _locales = require("../../../locales");
var _reactI18next = require("react-i18next");
var _utils = require("../../../utils");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["action"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var LearnMore = exports.LearnMore = (0, _react.memo)((0, _react.forwardRef)(function (_ref, ref) {
  var action = _ref.action,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _locales.useStepLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useContext = (0, _react.useContext)(_utils.LinkContext),
    stepDetailPageLinkUrl = _useContext.stepDetailPageLinkUrl;
  var _useContext2 = (0, _react.useContext)(_utils.AnalyticsSourceContext),
    source = _useContext2.source;
  var _useGikiAnalytics = (0, _utils.useGikiAnalytics)(),
    saveGikiAnalyticsEvent = _useGikiAnalytics.saveGikiAnalyticsEvent,
    GikiAnalyticsEventType = _useGikiAnalytics.GikiAnalyticsEventType;
  var _trackingOnPress = function _trackingOnPress() {
    if (!(action != null && action.id)) return;
    saveGikiAnalyticsEvent({
      event: GikiAnalyticsEventType.stepLearnMore,
      source: source,
      content: action.id
    });
  };
  if (!stepDetailPageLinkUrl || !(action != null && action.param)) return null;
  return (0, _jsxRuntime.jsx)(_Button.Button, Object.assign({
    href: (0, _utils.ReplaceParam)(stepDetailPageLinkUrl, action.param),
    testID: "LearnMore",
    type: _Button.ButtonType.normal,
    label: t('step:buttons.learnMore'),
    ref: ref,
    trackingOnPress: _trackingOnPress
  }, props));
}));